import { gsap, ScrollTrigger } from '../foundation/animation.js';

export function initCompanyPage() {
  const philosophySection = document.querySelector('.p-company__philosophy');
  if (!philosophySection) return;

  const philosophyText = philosophySection.querySelector('.js-philosophy-text');
  const visionText = philosophySection.querySelector('.js-vision-text');
  const canvas = document.getElementById('threejs-canvas');

  if (philosophyText && visionText) {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 768px)", () => {
      // 共通のアニメーション関数
      // direction: 'in' (現れる), 'out' (消える)
      // from: 'bottom' (下から), 'top' (上から)
      const animateContent = (container, direction = 'in', from = 'bottom') => {
        const label = container.querySelector('.p-company__section-label');
        const lines = container.querySelectorAll('.p-company__line span');

        // アニメーションの競合を防ぐために事前にkill
        const targets = [container, lines];
        if (label) targets.push(label);
        gsap.killTweensOf(targets);

        const tl = gsap.timeline({ overwrite: true });

        // コンテナ自体の表示設定
        if (direction === 'in') {
          gsap.set(container, { opacity: 1, visibility: 'visible' });
        }

        // ラベル
        if (label) {
          tl.to(label, {
            opacity: direction === 'in' ? 1 : 0,
            y: direction === 'in' ? 0 : (from === 'bottom' ? -20 : 20),
            duration: 0.5,
            ease: "power2.out"
          }, 0);
        }

        // テキスト行
        if (lines.length > 0) {
          if (direction === 'in') {
            gsap.set(lines, { y: from === 'bottom' ? "100%" : "-100%", opacity: 0 });
          }
          tl.to(lines, {
            y: direction === 'in' ? "0%" : (from === 'bottom' ? "-100%" : "100%"),
            opacity: direction === 'in' ? 1 : 0,
            duration: 0.8,
            stagger: 0.1,
            ease: "power2.out"
          }, direction === 'in' ? 0.2 : 0);
        }

        if (direction === 'out') {
          tl.set(container, { opacity: 0, visibility: 'hidden' });
        }

        return tl;
      };

      // 初期状態のセット
      gsap.set([philosophyText, visionText], { position: 'absolute', top: 'calc(50% - 45px)', left: '50%', xPercent: -50, yPercent: -50, width: '100%' });
      gsap.set(visionText, { opacity: 0, visibility: 'hidden' });

      // 状態の初期化
      philosophyText.dataset.state = 'visible';
      visionText.dataset.state = 'hidden';

      animateContent(philosophyText, 'in', 'bottom');

      ScrollTrigger.create({
        trigger: philosophySection,
        start: "top top",
        end: "bottom bottom",
        onUpdate: (self) => {
          // チラつき防止のためヒステリシスを設定
          if (self.progress > 0.5) {
            if (visionText.dataset.state !== 'visible') {
              animateContent(philosophyText, 'out', 'bottom');
              animateContent(visionText, 'in', 'bottom');
              philosophyText.dataset.state = 'hidden';
              visionText.dataset.state = 'visible';
            }
          } else if (self.progress < 0.49) {
            if (philosophyText.dataset.state !== 'visible') {
              animateContent(visionText, 'out', 'top');
              animateContent(philosophyText, 'in', 'top');
              visionText.dataset.state = 'hidden';
              philosophyText.dataset.state = 'visible';
            }
          }
        }
      });
    });

    // 球体のフェードアウト（バリューセクションをトリガーにする）
    const valueSection = document.querySelector('.p-company__value-section');
    if (canvas && valueSection) {
      gsap.to(canvas, {
        opacity: 0,
        ease: "none",
        scrollTrigger: {
          trigger: valueSection,
          start: "top center",
          end: "center center",
          toggleActions: "play none none reverse",
        }
      });
    }
  }
}
